<template>
  <div >
    <div class="heard">
      <div class="heard_left_bgc">
        <div class="left">
          <div class="block" @click="$router.push({name:'index'})">
            <img src="@/assets/1681390719877.jpg" alt=""/>
          </div>
          <div class="name">老年多模态多媒体语料库切分标注平台</div>
        </div>
        <div class="right">
           <!-- <div class="block"  @click='go'>
            <img src="@/assets/ad1.png" alt="">
           </div>
           <div class="block"  @click='go'>
            <img src="@/assets/ad2.png" alt="">
           </div> -->
           <el-link style="margin-right:30px;color:#fff;cursor: pointer;" @click="goIndex">首页</el-link>
           <el-link style="margin-right:30px;color:#fff;cursor: pointer;" @click="gommcgd">相关文档</el-link>
            <el-link style="margin-right:30px;color:#fff;cursor: pointer;" @click="goTamplateData">样本数据</el-link>
           <template v-if="userInfo && userInfo.userId">
            <el-link style="margin-right:30px;color:#fff;cursor: pointer;" @click="goUser">档案中心</el-link>
            <el-link style="margin-right:30px;color:#fff;cursor: pointer;" @click="customized">量表定制</el-link>
            <el-link style="margin-right:30px;color:#fff;cursor: pointer;" @click="goAudioAnalysis">音频分析</el-link>
          </template>
        
           <template v-if="userInfo.userName">
            <el-popover placement="bottom" width="60" trigger="click">
              <!-- <div class="popoverRow" @click="goIndex">首页</div> -->
              <div class="popoverRow" @click="changePassword">修改密码</div>
              <!-- <div class="popoverRow" @click="goUser">档案中心</div> -->
              <div class="popoverRow" style="margin-bottom: 0" @click="settingNameFn">
                修改医生姓名
              </div>
              <div class="popoverRow" @click="loginOut" style="margin-top:10px">退出登录</div>
              <i slot="reference" class="el-icon-user-solid" style="margin-right:30px;font-size:38px;cursor: pointer;"></i>
            </el-popover>
           </template>
           <template v-else>
            <el-link style="margin-right:30px;color:#fff;cursor: pointer;" @click="loginVisible = true">登录</el-link>
          </template>
        </div>
      </div>
      
    </div>
    <el-dialog
      :modal="false"
      title="修改医生姓名"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-input v-model="name"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" @click="submit" style="background-color:#568156;border-color:#568156"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog title="修改密码" :visible.sync="dialogFormVisible" width="25%">
      <el-form :model="form" :rules="rules" ref="ruleForm">
        <el-form-item label="用户名" label-width="80px" prop="userName">
          <el-input v-model="form.userName" disabled></el-input>
        </el-form-item>
        <el-form-item label="新密码" label-width="80px" prop="userPassword">
          <el-input v-model="form.userPassword"></el-input>
        </el-form-item>
        <el-form-item
          label="确认密码"
          label-width="80px"
          prop="comfirmPassword"
        >
          <el-input v-model="form.comfirmPassword"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="dialogFormVisible = false"
          >取 消</el-button
        >
        <el-button size="medium" type="primary" style="background-color:#568156;border-color:#568156" @click="comfirmChnagePassword"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog title="登录" :visible.sync="loginVisible">
      <login @loginSuccess="  loginVisible = false"/>
     </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  settingName,
  getUserInfo,
  changePasswordRequest,
} from "../utils/login";
import login from '../views/login.vue'
export default {
  components:{
    login
  },
  data() {
    return {
      model: false,
      loginVisible:false,
      name: "",
      dialogVisible: false,
      dialogFormVisible: false,
      form: {
        userName: "",
        userPassword: "",
        comfirmPassword: "",
      },
      rules: {
        userName: [
          { required: true, message: "用户名不能为空", trigger: "blur" },
        ],
        userPassword: [
          { required: true, message: "新密码不能为空", trigger: "blur" },
        ],
        comfirmPassword: [
          { required: true, message: "确认密码不能为空", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  mounted() {
    this.form.userName = this.userInfo.userName;
    this.name = this.userInfo.doctorName;
  },
  methods: {
    goAudioAnalysis(){
      this.$router.push({name:'audioAnalysis'})
    },
    goTamplateData() {
      this.$router.push({ name: 'tamplateData' })
    },
    gommcgd() {
      this.$router.push({ name: 'mmcgd' })
    },
    customized(){
      this.$router.push({name:'customized'})
    },
    go(){
      window.open('http://www.whsyy.net/','_blank')
      window.location.href=''
    },
    loginOut(){
    this.$store.commit("SET_USER_INFO", {})
    this.$router.push('/')
  },
    changePassword() {
      this.dialogFormVisible = true;
    },
    comfirmChnagePassword() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (this.form.comfirmPassword != this.form.userPassword) {
            this.$message({
              message: "两次输入的密码不一致！",
            });
            return;
          } else {
            let params = {
              id: this.userInfo.userId,
              userPassword: this.form.userPassword,
            };
            changePasswordRequest(params).then((res) => {
              this.dialogFormVisible = false
              this.$router.push('/')
              this.$message({
                message: "密码修改成功",
                type: "success",
              });
            });
          }
        }
      });
    },
    submit() {
      const params = {
        id: this.userInfo.userId,
        doctorName: this.name,
      };
      if (!this.name) {
        this.$message({
          message: "姓名不能为空！",
        });
        return;
      }
      settingName(params).then(() => {
        this.dialogVisible = false;
        getUserInfo(this.userInfo.userId).then((res) => {
          let result = res.data;
          this.$store.commit("SET_USER_INFO", result);
        });
        this.$message({
          message: "修改成功",
          type: "success",
        });
      });
    },
    handleClose() {
      this.dialogVisible = false;
    },
    settingNameFn() {
      console.log(this.userInfo);
      this.model = false;
      this.dialogVisible = true;
    },
    goUser() {
      this.$router.push("/user");
    },
    goIndex() {
      this.$router.push("/");
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .heard {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    height: 68px;
    /* padding: 0px 60px; */
    display: flex;
    align-items: center;
    justify-content: flex-start;
    align-items: center;
    color: #374567;
    font-size: 24px;
    background-color: #4F585F;
    box-shadow: 0 10px 17px 1px #e7eef9;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .portrait-wrap{
    position: absolute;
    right: 60px;
    width: 30px;
    height: 30px;
    top: 10px;
  }
  .head_left {
    padding-left: 60px;
    color: #fff;
    position: relative;
    z-index: 25;
    cursor: pointer;
  }
  .heard_left_bgc {
    width: 100%;
    height: 68px;
    position: absolute;
    left: 0;
    z-index: 20;
    color:#568156 ;
    background: #4F585F !important;
    display: flex;
    justify-content: space-between;
    .left{
      display: flex;
      height: 100%;
      align-items: center;
      margin-left: 30px;
      .block{
        border-radius: 2px;
        width: 139px;
        height: 41px;
        // background: #D9D9D9;
        cursor: pointer;
        margin-right: 30px;
        overflow: hidden;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .name{
        color: #fff;
        font-size: 18px;
      }
    }
    .right{
      display: flex;
      height: 100%;
      align-items: center;
      margin-left: 30px;
      .block{
        border-radius: 2px;
        width: 139px;
        height: 41px;
        margin-right: 30px;
        cursor: pointer;
        overflow: hidden;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .heard .head_left {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .heard .head_left .logo {
    width: 209px;
  }
  
  .head_right {
    position: relative;
    width: 370px;
    margin-right: 100px;
  }
  .head_right .left {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 185px;
  }
  .head_right .right {
    position: absolute;
    right: 100px;
    top: 0;
    height: 100%;
    width: 185px;
  }
  .heard .head_right .organisation_logo {
    width: 370px;
  }
</style>
<style lang="less">
.el-popover {
  min-width: 90px;
}
.popoverRow {
  text-align: center;
  cursor: pointer;
  margin-bottom: 10px;
}
.popoverRow :hover {
  color: rgba(2, 72, 167);
}
</style>
